import { createReducer } from 'typesafe-actions';

import { TGetChildrenAction, GetChildrenTypes } from '@/features/company-members/store/types/company-members.types';
import { IProfileState } from '@/store/types/profile.types';

const initialState: IProfileState = {
  profiles: {
    state: [],
  },
};
export const companyMemberReducer = (handleAsyncProfileReducer) =>
  createReducer<IProfileState, TGetChildrenAction>(initialState)
    .handleType(GetChildrenTypes.GET_CHILDREN_USER, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { children: {} }),
    )

    .handleType(GetChildrenTypes.GET_CHILDREN_USER_FAIL, (state, action) =>
      handleAsyncProfileReducer(state, action.userId, { children: {} }, { error: action.error }),
    )

    .handleType(GetChildrenTypes.GET_CHILDREN_USER_SUCCESS, (state, action) =>
      handleAsyncProfileReducer(
        state,
        action.parentUserId,
        { children: {} },
        { state: { children: action.children, maxItems: action?.maxItems }, error: undefined },
      ),
    );
